import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Rx';

import { GUID } from "app/brightserve/brightserve.module";
import { Person } from "app/shared/shared.module";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
@Injectable()
export class PersonService {
    constructor(private http: HttpClient) { }

    GetPersonDetails(Id: GUID): Observable<Person> {
        return this.http.get("/patient/" + Id).map((res: any) => new Person(res.Patient) || {});
    };
}



// WEBPACK FOOTER //
// ./src/app/person/person.service.ts